<template>
    <div>
        <el-dialog
            :title="title"
            width="600px"
            :visible="show"
            :before-close="beforeClose"
           
            @close="onCancelClick"
        >
            <el-form
                :model="form"
                ref="form"
                label-width="150px"
                label-position="right"
                :rules="rules"
                 v-loading="processing"
            >
                <el-form-item label="User" prop="authenticate_id" v-if="!data">
                    <el-autocomplete
                        popper-class="authenticate-autocomplete"
                        v-model="selected_authenticate"
                        :fetch-suggestions="searchUser"
                        placeholder="Type in name"
                        @select="onUserSelect">
                    <i
                        class="el-icon-edit el-input__icon"
                        slot="suffix">
                    </i>
                    <template slot-scope="{ item }">
                        <div class="display_name">{{ item.display_name||item.email }}</div>
                        <span class="email">{{ item.email }}</span>
                    </template>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="Permission level" prop="permission_level_id">
                    <!-- <el-input v-model="form.asset_name" autocomplete="off" clearable></el-input> -->
                    <el-select v-model="form.permission_level_id" placeholder="Please select" class="permission_level_id">
                        <el-option
                            v-for="item in permissionLevels"
                            :key="item.sub_permission_level_id"
                            :label="item.name"
                            :value="item.sub_permission_level_id"
                        >
                            <span style="float: left">{{ item.name }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.code }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer"  v-loading="processing">
                <el-button @click="onCancelClick">Cancel</el-button>
                <el-button @click="onSubmit" type="primary">Save</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "PermissionNew",
    props: {
        data: Object,
        show: { default: false },
        onClose: Function
    },
    data() {
        return {
            form: {
                authenticate_id: "",
                permission_level_id: "",
            },
            selected_authenticate: "",
            // permissionLevels: [],
            processing: false,
            processing_search: false,
            rules: {
                label: [
                    {
                        required: true,
                        message: "Label is required",
                        trigger: "blur"
                    }
                ],
                asset_name: [
                    {
                        required: true,
                        message: "Currency is required",
                        trigger: "blur"
                    }
                ],
                address: [
                    {
                        required: true,
                        message: "Address is required",
                        trigger: "blur"
                    }
                ],
                
            },
        };
    },
    watch: {
        data(newData) {
            if(newData) {
                this.init(newData);
            }
            
        }
    },
    mounted() {
        // this.loadPermissionLevelData();
        if(this.data) {
            this.init(this.data)
        }
        
        // this.searchUser();
    },
    computed: {
        ...mapState({
            adminPerms: state => state.adminPerms
        }),
        title(){
            if(!this.data) {
                return "Add a new permission";
            }
            return `Edit ${this.data.display_name||this.data.email} permission`
        },
        permissionLevels() {
            if(this.adminPerms && this.adminPerms.admin) {
                return this.adminPerms.admin.filter(a => { return a.visibility == 1; });
            }
            return [];
        }
    },
    methods: {
        ...mapActions(["request", "getError"]),
        beforeClose(done = () => {}) {
            this.form.authenticate_id = "";
            this.form.permission_level_id = "";
            done();
        },
        init(data) {
            this.form.authenticate_id = data.authenticate_id;
            this.form.permission_level_id = data.permission_level_id;
            if(data.display_name) {
                this.selected_authenticate = data.display_name;
            }
        },
        onCancelClick(reload = false) {
            this.onClose(reload);
            this.form.authenticate_id = "";
            this.form.permission_level_id = "";
            this.selected_authenticate = "";
        },
        loadPermissionLevelData() {
            let ctrl = this;
            ctrl.processing = true;
            ctrl.request({
                method: "GET",
                endpoint: `permission/level`
            })
                .then(({ data = {} }) => {
                    ctrl.permissionLevels = data;
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "PERMISSION_ERROR",
                        message: "Get permission level Failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    ctrl.processing = false;
                });
        },
        searchUser(queryString = "", callback = () => {}) {
            let ctrl = this;
            ctrl.processing_search = true;
            let query = `authenticate?
                limit=10&where=activated=1 
                AND disabled=0 `;
            //     AND display_name NOT LIKE '%admin%' 
            //     AND email NOT LIKE '%admin%'
            //     AND display_name NOT LIKE '%support%' 
            // `;
            if(typeof queryString == 'string' && queryString.trim().length > 0) {
                query += ` AND (display_name LIKE '%${queryString}%' OR email LIKE '%${queryString}%') `
            }
            
            let endpoint = encodeURI(query);

            ctrl.request({
                method: "GET",
                endpoint
            })
                .then(({ data = {} }) => {
                    callback(data.results);
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "PERMISSION_ERROR",
                        message: "Get permission level Failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    ctrl.processing_search = false;
                });
        },
        onUserSelect(item) {
            this.selected_authenticate = item.display_name||item.email;
            this.form.authenticate_id = item.id;

        },
        onSubmit() {
            let ctrl = this;
            ctrl.processing = true;
            ctrl.request({
                method: "POST",
                endpoint: `permission`,
                data: ctrl.form
            })
                .then(() => {
                    this.$message({
                        message: "New permission has been added",
                        type: "success"
                    });
                    ctrl.onCancelClick(true);
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "PERMISSION_ERROR",
                        message: "Add permission Failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    ctrl.processing = false;
                });
        }
        
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.permission-detail-item {
    display: flex;
    line-height: 26px;
    border-bottom: 1px solid #ccc;
}
.permission-detail-form-settings {
    border: 1px solid #ccc;
}
.permission-detail-item .title {
    width: 200px;
    text-align: right;
    background-color: rgba(0, 0, 0, 0.1);
    border-right: 1px solid #ccc;
}

.permission-detail-item .title span {
    padding: 0 8px;
}
.permission-detail-item .value {
    flex: 1;
}
.permission-detail-item .value span {
    padding: 0 8px;
}

.permission-detail-item:last-child {
    border-bottom: none;
}
</style>
<style>
.authenticate-autocomplete li{
    line-height: 1.5em;
    padding: 7px;
}

.authenticate-autocomplete .display_name {
      text-overflow: ellipsis;
      overflow: hidden;
}
.authenticate-autocomplete .email {
      font-size: 12px;
      color: #b4b4b4;
    }

.highlighted .email {
    color: #ddd;
}

.permission_level_id {
    width: 100%;
}
.permission_level_id span {
    max-width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>